<template>
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 md4>
            <v-text-field v-model="shipmentId"
                          append-icon="search"
                          label="#"
                          @click:append="fetch"
                          clearable
                          @keyup.enter.native="fetch"
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field v-model="trackingNumber"
                            append-icon="search"
                            :label="$tc('attrs.tracking_number')"
                            @click:append="fetch"
                            clearable
                            @keyup.enter.native="fetch"
                            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-select v-model="status"
                      :items="statuses"
                      item-value="id"
                      item-text="name"
                      :label="$tc('attrs.status')"
                      @change="fetch"
                      ></v-select>
          </v-flex>

          <v-flex xs12 md4>
            <v-select v-model="source"
                      :items="sources"
                      item-value="id"
                      item-text="name"
                      :label="$tc('attrs.source')"
                      ></v-select>
          </v-flex>

          <v-flex xs12 md4 v-if="!$auth.isCust()">
            <v-text-field v-model="email"
                          append-icon="search"
                          :label="$t('attrs.email')"
                          @click:append="fetch"
                          clearable
                          @keyup.enter.native="fetch"
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-select v-model="carrierId"
                      :items="carriers"
                      item-value="id"
                      item-text="name"
                      :label="$tc('models.carrier')"
                      @change="fetch"
                      ></v-select>
          </v-flex>

          <v-flex xs12 md4>
            <v-select v-if="(this.source == 'shopify' || this.source == 'woocommerce') && (this.shops.length > 2)"
                      v-model="storeId"
                      :items="shops"
                      item-value="id"
                      item-text="params.shop"
                      :label="$tc('models.store')"
                      @change="fetch"
                      ></v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import Carrier from '@/client/carrier'
import Store from '@/client/store'

export default {
  name: 'ShipmentFilterComp',

  props: {
    enums: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      stores: [],
      shops: [],
      carriers: [],
      shipmentId: '',
      carrierId: '',
      email: '',
      status: '',
      source: '',
      storeId: '',
      trackingNumber: ''
    }
  },

  components: {
  },

  computed: {
    statuses () {
      const arr = [
        { id: '', name: this.$t('all') }
      ]
      if (!this.enums.shipments_status) { return arr }

      for (let k in this.enums.shipments_status) {
        arr.push({ id: k, name: this.$t('list.statuses.' + k) })
      }
      return arr
    },

    sources () {
      return [
        { id: '', name: this.$t('all') },
        { id: 'app', name: this.company },
        { id: 'shopify', name: 'Shopify' },
        { id: 'woocommerce', name: 'WooCommerce' },
        { id: 'manual', name: 'Manual' }
      ]
    }
  },

  methods: {
    fetch () {
      this.$emit('fetch', {
        shipmentId: this.shipmentId,
        carrierId: this.carrierId,
        email: this.email,
        status: this.status,
        source: this.source,
        store_id: this.storeId,
        trackingNumber: this.trackingNumber
      }, true)
    },

    async fetchCarriers () {
      this.carriers = [
        { id: '', name: this.$t('all') }
      ]
      try {
        this.carriers = this.carriers.concat(await Carrier.fromShipments())
      } catch (err) {
        this.handleErr(err)
      }
    },
  },

  watch: {
    source () {
      if (this.source == 'shopify' || this.source == 'woocommerce') {
        this.storeId = ''
        this.shops = this.stores.filter( store => store.provider == this.source)
        this.shops.unshift({ id: '', params: { shop: this.$t('all') } })
      }

      this.fetch()
    },
  },

  async mounted () {
    this.stores = await new Store().getStores({shipment: true})
    this.fetchCarriers()
    if (this.$route.query.shipment_id) {
      this.shipmentId = this.$route.query.shipment_id
    }
  }
}
</script>
